// @ts-nocheck
import { gql } from '__generated__'

export const VERIFY_WALLET_SIGNATURE = gql(`
  mutation verifyWalletSignature(
    $walletAddress: String!
    $signature: String!
    $username: String
    $referrerId: String
  ) {
    verifyWalletSignature(
      data: {
        walletAddress: $walletAddress
        signature: $signature
        username: $username
        referrerId: $referrerId
      }
    )
  }
`)
